import { defineMessages } from 'react-intl';

export default defineMessages({
  addToCart: {
    id: 'components.ProductLayout.addToCart',
    defaultMessage: 'ADD TO SHOPPING CART',
  },
  buyAtMediaIntegration: {
    id: 'pricing.actions.buy',
    defaultMessage: 'Buy online at MediaIntegration',
  },
});
